module.exports = __webpack_public_path__ + "static/img/New password.00c8b4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/New password.png
// module id = 1292
// module chunks = 7